import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { ValidateId } from '../id-validator';
import { LeadService } from '../services/lead.service';
import { QuestionnaireService } from '../services/questionnaire.service';
import { HelpDialogRecycleComponent } from "../help-dialog-recycle/help-dialog-recycle.component";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';


@Component({
	selector: 'app-advisors',
	templateUrl: './advisors.component.html',
	styleUrls: ['./advisors.component.scss']
})
export class AdvisorsComponent implements OnInit {
	advisors: FormGroup;
	prevQID: any;
	private route$: Subscription;
	qID: any;
	currentStep;
	visibleQids;
	currentStepName;
	isMobilePhone: boolean;
	submitted;
	editQuestion;

	optionsConsultingCompany
	selectedConsultingCompany

	qFields = {
		0: [],
		1: [
			{ name: "firstName", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "lastName", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] }
		],
		2: [{ name: "idNumber", validators: [Validators.required, ValidateId] }],
		3: [{ name: "phoneNumber", validators: [Validators.required, this.validatePhone(), Validators.pattern("^[0-9]*$")] }],
		4: [{ name: "email", validators: [Validators.required, Validators.pattern("^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,5})$")] }],
		5: [{ name: "consulting", validators: [Validators.required] }],
		6: [{ name: "consultingCompany" }]
	};
	modalRef: NgbModalRef | null = null;

	constructor(
		private fb: FormBuilder,
		private questionnaireService: QuestionnaireService,
		private activeRoute: ActivatedRoute,
		private router: Router,
		private leadService: LeadService,
		private modalService: NgbModal
	) { }

	ngOnInit() {
		this.questionnaireService.setIsAdvisor(true);

		this.questionnaireService.dataChangedEvent.subscribe(() => {
			this.advisors.reset();
		});

		this.optionsConsultingCompany = [
			{ label: 'ADVISORS.Q6.A1', id: "inner", class: "internal-cycle" },
			{ label: 'ADVISORS.Q6.A2', id: "outer", class: "external-cycle" }
		];

		this.selectedConsultingCompany = "1";

		this.createForm();

		this.route$ = this.activeRoute.params.subscribe(params => {
			console.log("-----------------------------> params", params);
			this.prevQID = this.qID;
			this.qID = params.qid;
			this.editQuestion = null;
			this.currentStepName = "advisors";


			if (params.qid === "all") {
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
				this.clearPreviousQuestionValidators();
			} else {
				this.setValidators();
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
			}
		});
	}

	createForm() {
		this.currentStep = this.questionnaireService.getStep("advisors");
		this.advisors = this.fb.group({
			firstName: this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[0].answerValue,
			lastName: this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[1].answerValue,
			idNumber: this.questionnaireService.getQuestion(this.currentStep, "2").answer.fields[0].answerValue,
			phoneNumber: this.questionnaireService.getQuestion(this.currentStep, "3").answer.fields[0].answerValue,
			email: this.questionnaireService.getQuestion(this.currentStep, "4").answer.fields[0].answerValue,
			consulting: this.questionnaireService.getQuestion(this.currentStep, "5").answer.fields[0].answerValue,
			consultingCompany: this.questionnaireService.getQuestion(this.currentStep, "6").selectedAnswer,
		});
	}

	validatePhone(): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } => {
			if (control.value.includes("בחר")) {
				return {
					required: true
				};
			}
			if (this.isMobilePhone && control.value && control.value.length < 10) {//isMobilePhone not working
				return {
					minlength: true
				};
			} else if (!this.isMobilePhone && control.value && control.value.length < 9) {//isMobilePhone not working
				return {
					minlength: true
				};
			}
		};
	}

	setValidators() {
		// if (this.prevQID) {
		this.clearPreviousQuestionValidators();
		// }
		for (let i = 0; i < this.qFields[this.qID].length; i++) {
			let field = this.qFields[this.qID][i];
			this.advisors.controls[field.name].setValidators(field.validators);
			this.advisors.controls[field.name].updateValueAndValidity();
		}
		this.submitted = false;
	}

	setValidatorsArray() {
		this.questionnaireService.clearAllQuestionValidators(this.advisors.controls, this.qFields, false);
		this.questionnaireService.setCurrentQuestionValidators(this.qID, this.advisors.controls, this.qFields, "2", false);

		this.submitted = false;
	}

	clearPreviousQuestionValidators() {
		console.log("clearPreviousQuestionValidators()");

		let keys = Object.keys(this.qFields);

		for (let i = 0; i < keys.length; i++) {

			for (let j = 0; j < this.qFields[keys[i]].length; j++) {
				this.advisors.controls[this.qFields[keys[i]][j].name].setValidators(null);
				this.advisors.controls[this.qFields[keys[i]][j].name].updateValueAndValidity();
			}
		}
	}

	nextClick(qID, answers) {
		if (answers) {
			this.questionnaireService.updateMetaData(this.currentStep, qID, answers);
			this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
		} else if (qID === 0) {
			this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
		}

		// if(qID === "3" && this.leadService.queryObjParams && this.leadService.queryObjParams.caID) { //short lead only from external URL: 
		// 	let currentStep = this.questionnaireService.getActiveStep();
		// 	let prefixLength = currentStep.questions[1].answer.fields[0].answerValue.length === 10 ? 3 : 2;

		// 	let cycleType = this.questionnaireService.getCycleType();
		// 	let abandonCampainCode = (cycleType === 'inner') ? '1097' : '1095';

		// 	let lead: Lead = {
		// 		campaign_code: abandonCampainCode,
		// 		first_name: currentStep.questions[0].answer.fields[0].answerValue,
		// 		last_name: currentStep.questions[0].answer.fields[1].answerValue,
		// 		Id: currentStep.questions[1].answer.fields[0].answerValue,
		// 		id_type: '1',
		// 		phone_1_prefix: currentStep.questions[2].answer.fields[0].answerValue.substring(0, prefixLength),
		// 		phone_1_number: currentStep.questions[2].answer.fields[0].answerValue.substring(prefixLength, currentStep.questions[1].answer.fields[0].answerValue.length)
		// 	  };

		// 	  this.leadService.resetGuid();
		// 	  this.leadService.sendLead(lead,false,false).subscribe(
		// 		data => {
		// 		  console.log("send lead sucseed");
		// 		});
		// }
	}

	onSubmit({ value, valid }: { value: any, valid: boolean }) {
		console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>  onSubmit():  value=", value, "valid=", valid);
		this.submitted = true;

		if (valid) {
			let q;
			let submitQID = (this.qID !== "all") ? this.qID : this.editQuestion;
			q = this.qFields[submitQID];

			let values = q.map(r => {
				return value[r.name];
			});

			if (this.qID !== "0") {//0 = intro
				this.questionnaireService.sendGA(this.currentStep, this.qID, values);
			}

			if (this.qID === "6") { // Q6 logic for consulting company
				const cycleType = value["consultingCompany"];
				this.questionnaireService.setCycleType(cycleType);

				if (cycleType === "inner") {
					this.router.navigate(['/questionnaire']).then(() => {
						this.openModalForInnerCycle();
					}).catch((error) => {
						console.error(error);
					});	
              return;
			}
				else if (cycleType === "outer") {
					// Navigate as per original logic
					this.router.navigate(['/questionnaire/user-details', 1]);
				}
			}


			this.nextClick(submitQID, values);
		}
	}

	editQuestionChange(qid) {
		this.qID = qid;
		this.setValidators();
	}


	private openModalForInnerCycle() {
		try {
			// Prepare advisor-specific data
			const advisorStep = this.questionnaireService.getStepByID("0");

			let firstNameAdvisor = '';
			let phoneAdvisorNumber = '';

			const question1 = this.questionnaireService.getQuestion(advisorStep, "1");
			const question3 = this.questionnaireService.getQuestion(advisorStep, "3");
			const question5 = this.questionnaireService.getQuestion(advisorStep, "5");

			if (question1 && question1.answer && question1.answer.fields[0]) {
				firstNameAdvisor = question1.answer.fields[0].answerValue || '';
			}

			if (question3 && question3.answer && question3.answer.fields[0]) {
				phoneAdvisorNumber = question3.answer.fields[0].answerValue || '';
			}	

			// Open the modal
			this.modalRef = this.modalService.open(HelpDialogRecycleComponent);

			// Pass parameters to the modal
			if (this.modalRef.componentInstance) {
				this.modalRef.componentInstance.advisorData = {
					isAdvisor: true,
					firstNameAdvisor,
					phoneAdvisorNumber
				};
			}

			// Handle modal results
			this.modalRef.result
				.then((result) => {
					if (result === 'Close click') {
						this.router.navigate(['/questionnaire']);
					}
				})
				.catch((dismissed) => {
					console.log('Modal dismissed:', dismissed);
					this.router.navigate(['/questionnaire']);
				});
		} catch (error) {
			console.error('Error opening modal:', error);
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/advisors/advisors.component.ts